import React, { useEffect, useState } from 'react';

import { ResizeHandle } from './resize-handle';

export const ResizableContainer: React.FC<{
  children: React.ReactNode;
  style?: React.CSSProperties;
  minHeight: number;
}> = ({ children, style, minHeight }) => {
  const [isResizing, setIsResizing] = useState(false);
  const [containerRef, setContainerRef] = React.useState<HTMLDivElement | null>(null);

  const handleMouseDown = () => {
    setIsResizing(true);
    document.body.style.cursor = 'ns-resize';
  };

  const handleMouseMove = (event: MouseEvent): void => {
    if (isResizing && containerRef) {
      const newHeight = event.clientY - containerRef.getBoundingClientRect().top + 16;
      if (newHeight >= minHeight) {
        containerRef.style.height = `${newHeight}px`;
      }
    }
  };

  const handleMouseUp = () => {
    setIsResizing(false);
    document.body.style.cursor = 'auto';
  };

  useEffect(() => {
    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing]);

  return (
    <div ref={setContainerRef} className="relative w-full" style={style}>
      {children}
      {
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <button
          // style={{ all: 'unset' }}
          className="resize-handle w-full cursor-ns-resize absolute bottom-0 flex justify-center items-center h-[24px] bg-transparent"
          onMouseDown={handleMouseDown}
        >
          <ResizeHandle orientation="horizontal" />
        </button>
      }
    </div>
  );
};
